import React, { Component } from 'react';
import { connect } from 'react-redux';
import LoadingOverlay from '../components/LoadingOverlay';
import CollectiveCard from '../components/CollectiveCard';
import { fetchCollective } from '../actions';

class ViewCollective extends Component {

  componentDidMount() {
    this.props.dispatch(fetchCollective(this.props.collectiveId));
  }

  render() {
    if (!this.props.collective || !this.props.collective.get('influencers')) return <div></div>;

    return (
      <div>
        <CollectiveCard
          collective={this.props.collective.toJS()}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    collective: state.get('collectives')
                          .get('items')
                          .get(`${state.get('location').get('options').get('id')}`),
    collectiveId: state.get('location').get('options').get('id'),
    isFetching: state.get('collectives').get('isFetching'),
  };
};

export default connect(mapStateToProps)(ViewCollective);



/** WEBPACK FOOTER **
 ** ./containers/ViewCollective.js
 **/